import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-pilates-al',
	options: {
		userFlags: ['hasAccessToPilatesVideos'],
		userTags: ['pilates'],
	},
	landing: {
		ids: ['loader-pilates-f', 'age-pilates-f'],
		route: {
			path: '/pilates-f-al',
			name: 'female-pilates-funnel-al',
		},
	},
	funnel: {
		id: 'ob-female-pilates-al',
		route: {
			path: '/pilates-f-al/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-pilates-al',
		},
		slug: 'activity-female-pilates-al',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-pilates-f-al',
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
	upgrade: {
		routeName: 'special-upsale',
	},
}

export default appAreaConfig
